import React from "react";
import { Linkedin, GraduationCap, Quote } from "lucide-react";

/* ===== Images (Keep your existing imports) ===== */
import Shray_Pathak from "../directorimages/Shray_Pathak.jpeg";
import Atharva from "../directorimages/atharva.jpg";
import shashi from "../directorimages/shashi.png";
import rajeev4 from "../directorimages/rajeev4.jpg";
import naveen from "../directorimages/Naveen1.png";
import Dr_Vivekanand_Shukla from "../directorimages/Vivekanand.png";

/* ===== Data ===== */
const directors = [
  {
    imgSrc: rajeev4,
    name: "Prof. Rajeev Ahuja",
    designation: "Chairman",
    message:
      "At TBIF, IIT Ropar, we foster innovation and entrepreneurship by offering startups access to labs, cloud tools, co-working space, mentorship, funding, investor connect, and research support. Our goal is to help students, faculty, and innovators turn ideas into impactful ventures and strengthen India’s entrepreneurial ecosystem.",
    scholar: "https://iitrpr.irins.org/profile/227381",
    linkedin: "https://scholar.google.com/citations?user=OqyvV_oAAAAJ",
  },
  {
    imgSrc: Shray_Pathak,
    name: "Dr. Shray Pathak",
    designation: "Faculty In-Charge",
    message:
      "TBIF at IIT Ropar is a critical driver for innovation and entrepreneurship in the region. By fostering a culture of creativity and enterprise, we aim to transform promising ideas into scalable solutions.",
    scholar: "https://scholar.google.com/citations?user=JId_NPEAAAAJ",
    linkedin: "https://www.linkedin.com/in/shray-pathak-4aa852300/",
  },
  {
    imgSrc: Atharva,
    name: "Atharva Poundarik",
    designation: "Director",
    message:
      "At TBIF, we are committed to creating a vibrant entrepreneurial ecosystem where students, faculty, and regional innovators collaborate to bring ideas to life.",
    scholar: "https://iitrpr.irins.org/profile/212275",
    linkedin: "https://www.linkedin.com/in/atharva-poundarik-44723b44/",
  },
  {
    imgSrc: shashi,
    name: "Dr. Shashi Shekhar Jha",
    designation: "Director",
    message:
      "Through TBIF, IIT Ropar is dedicated to empowering innovators with the tools, guidance, and environment necessary to turn concepts into impactful ventures.",
    scholar: "https://iitrpr.irins.org/profile/105191",
    linkedin: "https://www.linkedin.com/in/jhashashishekhar/",
  },
  {
    imgSrc: naveen,
    name: "Prof. Navin Kumar",
    designation: "Director",
    message:
      "TBIF serves as a catalyst for entrepreneurial growth, offering a nurturing ground for startups to innovate, iterate, and succeed.",
    scholar: "https://iitrpr.irins.org/profile/50300",
    linkedin: "https://www.linkedin.com/in/navin-kumar-a4a4a45/",
  },
  {
    imgSrc: Dr_Vivekanand_Shukla,
    name: "Dr. Vivekanand Shukla",
    designation: "Director",
    message:
      "Innovation thrives when ideas are nurtured with the right ecosystem. I am committed to guiding startups in transforming their vision into viable ventures.",
    scholar: "https://iitrpr.irins.org/profile/414198",
    linkedin: "https://www.linkedin.com/in/vivekanand-shukla-74412b59/",
  },
];

export default function DMssg() {
  return (
    <section className="bg-white py-24 px-6 border-b border-slate-100">
      <div className="max-w-7xl mx-auto">

        {/* ===== Heading ===== */}
        <div className="text-center mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">Board of Directors</h2>
          <div className="h-1 w-20 bg-blue-600 mx-auto rounded-full"></div>
          <p className="mt-4 text-slate-500 max-w-2xl mx-auto">
            Governing the strategic direction and ensuring the highest standards of academic and operational excellence.
          </p>
        </div>

        {/* ===== Executive Grid ===== */}
        <div className="grid md:grid-cols-2 gap-8">
          {directors.map((director, idx) => (
            <div
              key={idx}
              className="flex flex-col sm:flex-row bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-xl hover:border-blue-100 transition-all duration-300 overflow-hidden group"
            >
              {/* Image Section */}
              <div className="sm:w-2/5 relative overflow-hidden">
                <img
                  src={director.imgSrc}
                  alt={director.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  style={{ minHeight: "280px" }}
                />
                {/* <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent sm:bg-gradient-to-r"></div> */}
                
                {/* Overlay Name (Mobile only/Design choice) */}
                <div className="absolute bottom-0 left-0 p-4 text-white sm:hidden">
                    <h3 className="font-bold text-lg">{director.name}</h3>
                    <p className="text-xs opacity-90">{director.designation}</p>
                </div>
              </div>

              {/* Content Section */}
              <div className="sm:w-3/5 p-8 flex flex-col justify-between relative bg-slate-50/50">
                <Quote className="absolute top-6 right-6 text-blue-100 w-12 h-12 rotate-180" />
                
                <div>
                    <div className="hidden sm:block mb-4">
                        <h3 className="text-xl font-bold text-slate-900 group-hover:text-blue-700 transition-colors">
                        {director.name}
                        </h3>
                        {director.designation && (
                        <p className="text-sm font-semibold text-blue-600 uppercase tracking-wider">
                            {director.designation}
                        </p>
                        )}
                    </div>

                    <p className="text-slate-600 text-sm leading-relaxed italic relative z-10">
                    "{director.message}"
                    </p>
                </div>

                {/* Links */}
                <div className="mt-6 flex gap-3 pt-6 border-t border-slate-200">
                  <a
                    href={director.scholar}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-xs font-bold text-slate-500 hover:text-blue-600 transition-colors px-3 py-2 rounded-lg hover:bg-white border border-transparent hover:border-slate-200"
                  >
                    <GraduationCap size={16} /> Google Scholar
                  </a>
                  <a
                    href={director.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-xs font-bold text-slate-500 hover:text-blue-700 transition-colors px-3 py-2 rounded-lg hover:bg-white border border-transparent hover:border-slate-200"
                  >
                    <Linkedin size={16} /> LinkedIn
                  </a>
                </div>

              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}